import React from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Header from '../layouts/Header';
import { feeMenu } from '../data/Menu';

const quickNavItems = feeMenu.filter((m) => m.link !== '/fee/home');

const FeeHome = () => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Header />
      <main className="main main-app p-3 p-lg-4">
        <Container fluid className="px-0">
          <div className="mb-3">
            <h2 className="mb-1">การเงิน / ค่าใช้จ่ายนักเรียน</h2>
            <p className="text-muted mb-0">
              จัดการรายการค่าใช้จ่าย ตั้งราคาตามชั้น/สาย (สามัญ–ศาสนา) ตามปีการศึกษาและภาคเรียน
            </p>
          </div>

          <Row className="g-2 mb-4">
            {quickNavItems.map((item) => (
              <Col key={item.link} xs={6} sm={4} md={3} xl={3}>
                <Card
                  className="h-100 text-center border-0 shadow-sm"
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate(item.link)}
                >
                  <Card.Body className="py-4 px-2">
                    <i className={`${item.icon} fs-2 text-primary mb-2 d-block`} />
                    <span className="fw-medium">{item.label}</span>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <Card className="border-0 shadow-sm">
            <Card.Body>
              <h5 className="mb-3">ลำดับการตั้งค่า</h5>
              <ol className="mb-0 ps-3">
                <li className="mb-2">
                  <strong>รายการค่าใช้จ่าย</strong> — สร้างรายการ เช่น ค่าเทอม, ค่าไฟฟ้า, ค่าหอ, ค่ากระดาษสอบ
                </li>
                <li className="mb-2">
                  <strong>งวด/ภาคเรียน</strong> — เปิดงวดเรียกเก็บตามปีการศึกษา + ภาคเรียน (1/2)
                </li>
                <li className="mb-2">
                  <strong>ตั้งราคาตามชั้น/สาย</strong> — กำหนดราคาต่อระดับชั้นและโปรแกรม แยกสาย
                  สามัญ / ศาสนา / เก็บทุกคน
                </li>
                <li>
                  <strong>ออกบิล / รับชำระ</strong> — ออกใบแจ้งหนี้รายนักเรียนตามงวด
                  รับชำระ (เงินสด/โอน) พิมพ์ใบเสร็จ และติดตามยอดค้าง
                </li>
              </ol>
            </Card.Body>
          </Card>
        </Container>
      </main>
    </React.Fragment>
  );
};

export default FeeHome;
